import {
  BROWSE_STORES,
  CENTRE,
  WHATS_HAPPENING,
  OPENING_HOURS,
  DINING,
} from '../paths'

export const CENTRE_TEMPLATE = 'centre'
export const SERVICE_TEMPLATE = 'service'
export const STORY_TEMPLATE = 'story'
export const OFFER_TEMPLATE = 'offer'
export const NEWS_TEMPLATE = 'news'
export const EVENT_TEMPLATE = 'event'
export const STORE_TEMPLATE = 'store'
export const CINEMA_TEMPLATE = 'movie'
export const CENTRE_SERVICES = 'centre-services'

export const ENTRY_TEMPLATES = [
  SERVICE_TEMPLATE,
  STORY_TEMPLATE,
  OFFER_TEMPLATE,
  NEWS_TEMPLATE,
  EVENT_TEMPLATE,
  STORE_TEMPLATE,
  CINEMA_TEMPLATE,
]

export const TEMPLATE_WHITELIST = [
  { template: 'announcements', redirect: `/:${CENTRE}` },
  { template: 'centre-info', redirect: OPENING_HOURS },
  { template: 'centre-information', redirect: OPENING_HOURS },
  { template: 'contact', redirect: OPENING_HOURS },
  { template: 'concierge', redirect: `/:${CENTRE}` },
  { template: 'deals', redirect: WHATS_HAPPENING },
  { template: 'development', redirect: `/:${CENTRE}` },
  { template: 'event', redirect: WHATS_HAPPENING },
  { template: 'events', redirect: WHATS_HAPPENING },
  { template: 'gifts', redirect: `/:${CENTRE}` },
  { template: 'hands-free-shopping', redirect: `/:${CENTRE}` },
  { template: 'hours', redirect: OPENING_HOURS },
  { template: 'info', redirect: OPENING_HOURS },
  { template: 'new-dining-and-entertainment', redirect: DINING },
  { template: 'news-and-events', redirect: WHATS_HAPPENING },
  { template: 'newsletter-popup-service', redirect: WHATS_HAPPENING },
  { template: 'offers', redirect: WHATS_HAPPENING },
  { template: 'ourstores', redirect: BROWSE_STORES },
  { template: 'search', redirect: `/:${CENTRE}` },
  { template: 'services', redirect: `/:${CENTRE}` },
  { template: 'stores', redirect: BROWSE_STORES },
]
